import Keycloak from "keycloak-js";
import { getEnv } from "@/utils/runtime-config";

const keycloak = new Keycloak({
  url: getEnv("VITE_KEYCLOAK_URL") || "",
  realm: getEnv("VITE_KEYCLOAK_REALM") || "",
  clientId: getEnv("VITE_KEYCLOAK_CLIENT_ID") || "",
});

export const getKeycloakInstance = () => keycloak;
